const baseConfig = (customConfig) => ({
  toolbarLocation: 'bottom',
  toolbarGroups:
    [
      { name: 'document', groups: ['mode', 'document', 'doctools'] },
      { name: 'forms' },
      { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
      { name: 'paragraph', groups: ['list', 'bidi'] },
      { name: 'links' },
      { name: 'styles' },
      { name: 'tools' },
      { name: 'insert' },
    ],
  removePlugins: 'elementspath,scayt,liststyle,tabletools,tableselection,stylescombo,format,font,justify,emoji',
  extraPlugins: 'autogrow',
  ...customConfig,
});

const configWithPlaceholder = (customConfig) => {
  const baseConfiguration = baseConfig(customConfig);
  return {
    ...baseConfiguration,
    extraPlugins: `editorplaceholder,${baseConfiguration.extraPlugins}`,
    editorplaceholder_delay: 250,
  };
};

const config = (customConfig) => {
  const {
    editorplaceholder,
  } = customConfig;

  if (editorplaceholder) {
    return configWithPlaceholder(customConfig);
  }
  return baseConfig(customConfig);
};

export { config };
